import request from '@/utils/request'

export async function getData(params) {
  return request({
    url: '/statistics/user_check/statistics',
    method: 'get',
    params,
  })
}
export async function exportReport(params) {
  return request({
    url: '/statistics/user_check/export',
    method: 'get',
    params,
  })
}
